import React from 'react';
import {
  Grid,
  Dialog,
  DialogTitle,
  DialogContent,
  IconButton
} from '@material-ui/core';
import { useStyles } from './styles';
import { CloseOutlined } from '@material-ui/icons';
import { CustomizedButton, CustomizedTypography } from '@components/Customized';

interface Props {
  open: boolean;
  onClose: () => void;
  onClick: () => void;
}

const CheckCircleIcon = () => {
  return (
    <svg
      width="43"
      height="42"
      viewBox="0 0 43 42"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <circle cx="21.5" cy="21" r="20" stroke="#3479FF" strokeWidth="2" />
      <g clipPath="url(#clip0)">
        <path
          d="M27.5002 15.9998L26.0902 14.5898L19.7502 20.9298L21.1602 22.3398L27.5002 15.9998ZM31.7402 14.5898L21.1602 25.1698L16.9802 20.9998L15.5702 22.4098L21.1602 27.9998L33.1602 15.9998L31.7402 14.5898ZM9.91016 22.4098L15.5002 27.9998L16.9102 26.5898L11.3302 20.9998L9.91016 22.4098Z"
          fill="#3479FF"
        />
      </g>
      <defs>
        <clipPath id="clip0">
          <rect
            width="24"
            height="24"
            fill="white"
            transform="translate(9.5 9)"
          />
        </clipPath>
      </defs>
    </svg>
  );
};

const ProfileUpdatePreviewDialog = (props: Props) => {
  const classes = useStyles();

  return (
    <Dialog
      open={props.open}
      classes={{ root: classes.root }}
      onClose={props.onClose}
    >
      <DialogTitle>
        <Grid container direction="column" alignItems="center">
          <Grid container justifyContent="center">
            <CheckCircleIcon />
            <Grid item className="closeButton">
              <IconButton size="small" onClick={props.onClose}>
                <CloseOutlined />
              </IconButton>
            </Grid>
          </Grid>
        </Grid>
      </DialogTitle>

      <DialogContent>
        <CustomizedTypography
          color="primary"
          variant="h4"
          fontWeight="700"
          align="center"
          gutterBottoms={24}
        >
          파트너 매칭을 위한
          <br />
          필수 정보를 먼저 입력해주세요!
        </CustomizedTypography>
      </DialogContent>

      <Grid container className={classes.containerGrid}>
        <CustomizedButton
          fullWidth
          variant="contained"
          color="primary"
          size="large"
          disableElevation
          className={'request'}
          onClick={props.onClick}
        >
          필수 정보 입력하기
        </CustomizedButton>
      </Grid>
    </Dialog>
  );
};

export default ProfileUpdatePreviewDialog;
